import React, { PureComponent, Fragment } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { I18n } from 'components/translate';

export default class FilePlayerThumbnailUploading extends PureComponent {
  render() {
    return (
      <Fragment>
        <label className="mt__0">
          <I18n label="player_section.thumbnail_title" />
        </label>

        <div className="file__content__thumbnail">
          <div className="file__content__thumbnail__image file__content__thumbnail__placeholder">
            <FontAwesomeIcon icon={['fal', 'image']} />
          </div>

          <label className="label__description">
            <I18n label="player_section.thumbnail_uploading" />
          </label>
        </div>
      </Fragment>
    );
  }
}
